import React from 'react';
import { faFlagCheckered } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateProjectStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const FinishModal = ({ project, setShow, handleStatus }) => {
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handleFinish = async prop => {
    await handleStatus(prop);
    dispatch(getRealEstateProjectStats(realEstate.id));
    handleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon={faFlagCheckered}
          title="Finalizar"
          size="1x"
          style={{ marginRight: 8, color: '#0b1727' }}
        />
        <Modal.Title>Finalizar emprendimiento</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          El emprendimiento de dirección{' '}
          <b>
            {project.location.street} {project.location.number}
          </b>{' '}
          se finalizará, lo que lo marcará como una operación realizada.
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?
        </div>

        <ModalButtonsContainer>
          <ButtonClose text="Cancelar" funcion={handleClose} />

          <ButtonAccept
            text="Confirmar"
            funcion={handleFinish}
            data={{
              id: project._id,
              status: 'finished'
            }}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

FinishModal.propTypes = {
  project: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default FinishModal;
